import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=4cd5084a&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=ts&"
export * from "./BaseInputDate.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=4cd5084a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5084a",
  null
  
)

export default component.exports